module.exports = __webpack_public_path__ + "img/P38-zh.c8eae275.png";